import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import ZoneFaultBlockData from "../../../Models/Content/ZoneFaultBlockData";
import ZoneFaultMain from "./ZoneFaultMain";

export default class ZoneFaultBlock extends EpiComponent<ZoneFaultBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["zone-fault-block"];
    return (
      <div className={cssClasses.join(" ")}>
        <ZoneFaultMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
